
export default {
  beforeMount () {
    let keyArr = ['city_scope', 'community_scope', 'account_scope'];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  methods: {
    /* 获取用户范围下拉列表 */
    userRangeList (regionIndex, communityIndex, fn1, fn2) {
      this.regionSelect((data) => {
        this.formList[regionIndex].options = data;
        fn1 && fn1(data); // 需要时可以添加回调
      }, null, '1,2');

      this.communitySelect((data) => {
        let arr = [];
        data.forEach((el) => {
          arr.push({key: `${el.value}`, title: el.label});
        });
        this.formList[communityIndex].options = arr;
        fn2 && fn2(arr); // 需要时可以添加回调
      });
    },
    /* 处理用户范围提交值 */
    rangeReqVal (param) {
      let scopeArr = ['city_scope', 'community_scope', 'account_scope'];
      scopeArr.forEach((el) => {
        for (let item in param) {
          if (el === item) {
            param.scope = param[item];
          }
        }
      });
      typeof param.scope === 'undefined' && (param.scope = '0');
      return param;
    },
    /* 处理用户范围返回值 */
    rangeResVal (values, res) {
      let scopeType = {
        1: 'city_scope',
        2: 'community_scope',
        3: 'account_scope'
      };
      let type = [1, 2].some(el => el === res.scope_type);
      values[scopeType[res.scope_type]] = type ? res.scope.split(',') : res.scope;

      // values[scopeType[res.scope_type]] = type ? formatScope() : res.scope;
      function formatScope () {
        let arr = [];
        res.scope && res.scope.split(',').forEach((el) => {
          arr.push(parseInt(el));
        });
        return arr;
      }

      return values;
    },

    /* 处理定时发送单选框 */
    handleDealyTime (value) {
      let index;
      this.formList.forEach((el, i) => {
        let props = el.props;
        if (props && props[0] === 'is_delay') {
          index = i;
        }
      });
      let delayTime = this.formList[index].dateProps[1].rules[0];
      let list = this.formList[index];
      value === 1 ? delayTime.required = true : delayTime.required = false;
      value === 1 ? list.pickerDisabled = false : list.pickerDisabled = true;
      this.$children[0].form.resetFields(['delay_time']);
    },

    /* 定位成功 */
    locaSuccess (val) {
      console.log('定位成功！: ', val);
      let obj = {
        map_lng: val.lng,
        map_lat: val.lat,
        address: val.address
      };
      this.$children[0].form.setFieldsValue(obj);
    },
    /* 限制修改上级 */
    limitEdit (res, keyArr) {
      res.can_delete === 0 && this.formList.forEach((el) => {
        keyArr.forEach((item) => {
          if (el.props && el.props[0] === item) {
            el.disabled = true;
          }
        });
      });
    }
  }
};
